import axios from "axios";

export default {
    methods: {
        async refreshAuth() {
            const refresh = localStorage.getItem('refresh');
            const deviceId = localStorage.getItem('deviceId');
            if (!refresh || !deviceId) {
                localStorage.clear();
                await this.$router.push({ name: 'login' });
                return;
            }

            try {
                const resData = (await axios.post('http://localhost:3000/api/admin/auth/refresh', {
                    refresh,
                    deviceId,
                })).data.data;

                if (!resData.accessToken || !resData.refreshToken) {
                    console.log('Invalid server response!');
                    return;
                }

                localStorage.setItem('jwt', resData.accessToken);
                localStorage.setItem('refresh', resData.refreshToken);
            } catch {
                localStorage.clear();
                await this.$router.push({ name: 'login' });
            }
        },
    }
}
